import badminton
    from "../assets/courts/badminton.avif";

import cricket
    from "../assets/courts/cricket.avif";

export const COURT_IMAGES = {

    badminton:
        badminton,

    cricket:
        cricket,
};